import { writable } from 'svelte/store';
import fetchNode from "./helpers/FetchNode.js";
import fetchNodeProduction from './helpers/FetchNodeProduction.js';

export const User = function() {
    const storageUser = localStorage.getItem("user"); 
    let user;
    try {
        user = JSON.parse(storageUser);
    } catch (e) {
        user = null;
    }
    const { subscribe, set } = writable(user);
    return {
        subscribe,
        logout: () => {
        	set(null);
        },
        login: async (username,password) => {
            const formData = new FormData()
            formData.append('email',username)
            formData.append('password',password)
        	let response =  await fetchNode('login',{user:username,password:password});

            if (response.accountRole.toLowerCase() !== 'cleaner') {
                let apiResponse = await fetchNodeProduction('/login',formData);
                response.accessToken = apiResponse.token;
            }

            if(typeof(response) === 'object' && response.token){
                set(response);
            }else{
                set(null);
            };
            return response;
        },
        loginWithToken: async(tokenApi, calendarObj) => {
            if(calendarObj.token){
                calendarObj.accessToken = tokenApi;
                calendarObj.loggedWithToken = true;
                set(calendarObj);
            } else {
                set(null);
            }
        }
    }
}()

User.subscribe(value => localStorage.setItem("user", JSON.stringify(value)));
export const modalReservation = writable({})
